import { getMobileOS, isInAppBrowser } from 'utils/detechMobileDevice';
import isGoogleBot from 'utils/urls/isGoogleBot';

export const APP_BANNER_HEIGHT = 52;

export const OPEN_APP_POPUP_EVENT = 'kamereo:open-app-popup';

const BANNER_DISMISSED_KEY = 'openAppBannerDismissed';

const POPUP_SHOWN_KEY = 'openAppPopupShown';

// localStorage có thể throw (private mode) → nhớ tạm trong session
const sessionFlags: Record<string, boolean> = {};

const readFlag = (key: string) => {
  try {
    return sessionFlags[key] || window.localStorage.getItem(key) === 'true';
  } catch (e) {
    return !!sessionFlags[key];
  }
};

const writeFlag = (key: string) => {
  sessionFlags[key] = true;

  try {
    window.localStorage.setItem(key, 'true');
  } catch (e) {
    // private mode: chỉ nhớ trong session
  }
};

const isAppOS = () => {
  const os = getMobileOS();

  return (os === 'ios' || os === 'android') && !isGoogleBot();
};

export const shouldShowAppBanner = () => isAppOS() && !readFlag(BANNER_DISMISSED_KEY);

export const dismissAppBanner = () => writeFlag(BANNER_DISMISSED_KEY);

/** Gọi sau lần add giỏ thành công; chỉ hiện popup đúng 1 lần. */
export const requestOpenAppPopup = () => {
  if (!isAppOS() || isInAppBrowser() || readFlag(POPUP_SHOWN_KEY)) return;

  writeFlag(POPUP_SHOWN_KEY);

  window.dispatchEvent(new Event(OPEN_APP_POPUP_EVENT));
};
